import Animated, { LinearTransition } from 'react-native-reanimated'
import { Button, ButtonLabel } from '~/components/ui/button'

export function SingleSelectChips<T extends string>({
  options,
  selected,
  onSelect,
}: {
  options: { label: string; value: T }[]
  selected: T | undefined
  onSelect: (value: T) => void
}) {
  return (
    <Animated.View layout={LinearTransition.duration(150)} className="flex-row flex-wrap gap-2">
      {options.map((opt) => {
        const isSelected = selected === opt.value

        return (
          <Button
            key={opt.value}
            variant={isSelected ? 'default' : 'outline'}
            size="sm"
            onPress={() => onSelect(opt.value)}>
            <ButtonLabel>{opt.label}</ButtonLabel>
          </Button>
        )
      })}
    </Animated.View>
  )
}
